import type { BeneficialOwner, BeneficialOwnerDataAttribute } from './beneficial-owner';
import type { BusinessDIData } from './business-di-data';
import type { BusinessDI } from './di';
import type { IdDIData } from './id-di-data';

const BootstrapOnlyBusinessSecondaryOwnersKey = 'business.secondary_owners';
const BootstrapOnlyBusinessPrimaryOwnerStake = 'business.primary_owner_stake';

type BusinessBootstrapOnlyProps = {
  [BootstrapOnlyBusinessSecondaryOwnersKey]?: Partial<Omit<BeneficialOwner, BeneficialOwnerDataAttribute.middleName>>[];
  [BootstrapOnlyBusinessPrimaryOwnerStake]?: number;
};

type BootstrapIgnoredBusinessDI =
  | BusinessDI.formationState
  | BusinessDI.formationDate
  | BusinessDI.beneficialOwnerExplanationMessage;

// TODO: expand in the future with InvestorProfileBootstrapData
type IdvBootstrapData = IdDIData & Omit<BusinessDIData, BootstrapIgnoredBusinessDI> & BusinessBootstrapOnlyProps;

type IdvOptions = {
  showCompletionPage?: boolean;
  showLogo?: boolean;
};

type KycBootstrapData = IdDIData;

export type { BootstrapIgnoredBusinessDI, IdvBootstrapData, IdvOptions, KycBootstrapData };
export { BootstrapOnlyBusinessPrimaryOwnerStake, BootstrapOnlyBusinessSecondaryOwnersKey };
